import authenticatedAxios from '@/commons/configuration/authenticated.axios'
import { ENVIRONMENT } from '@/commons/configuration'
import { ErrorUtils } from '@/commons/utils/error'
import { MediatedIssuanceType } from '@/commons/constants/application'
import i18n from '@/commons/translations/i18n'
import { MediatedPrice } from '@/commons/types/mediated.price'

export class MediatedIssuanceService {
    static async fetchPrices (): Promise<Array<MediatedPrice>> {
        try {
            const prices = await authenticatedAxios.get(ENVIRONMENT.mediatedIssuanceUrl)
            return prices.data
        } catch (e) {
            throw ErrorUtils.resolveRequestErrorEntity(e)
        }
    }

    static getPriceLabelText (label: string): string {
        switch (label) {
        case MediatedIssuanceType.COMMON:
            return i18n.t('placeOfIssue.mediatedIssuance.commonPrice').toString()
        case MediatedIssuanceType.DISCOUNT:
            return i18n.t('placeOfIssue.mediatedIssuance.discountPrice').toString()
        default:
            return i18n.t('placeOfIssue.mediatedIssuance.unknownPrice').toString()
        }
    }
}
